import { useEffect, useRef, useState } from "react";
import RightLongArrowIcon from "../../assets/svg/RightLongArrowIcon";
import ChevronLeftIcon from "../../assets/svg/ChevronLeftIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSubscriptionPlansThunk,
  setSelectedPlanDetails,
} from "../../store/actions/subscription.action";
import { useLocation, useNavigate } from "react-router-dom";

const SubscriptionPlanPage = () => {
  const dispatch = useDispatch();
  const { subscriptionPlans, loading, error } = useSelector(
    (state) => state.subscription
  );
  const location = useLocation();
  const routeState = location?.state;
  const subscriptionRef = useRef(false);
  const [activePlanId, setActivePlanId] = useState("free");
  const [monthlyPlan, setMonthlyPlan] = useState(null);
  const [yearlyPlan, setYearlyPlan] = useState(null);
  const [userActivePlan, setUserActivePlan] = useState("");
  // const [isCheckout, setIsCheckout] = useState(false);
  const navigate = useNavigate();
  const fetchSubscriptionPlans = () => {
    dispatch(fetchSubscriptionPlansThunk())
      .then((plans) => {
        if (plans && Array.isArray(plans)) {
          const month = plans.find((p) => p.recurringType === "month");
          const year = plans.find((p) => p.recurringType === "year");
          setMonthlyPlan(month);
          setYearlyPlan(year);
        }
      })
      .catch((error) =>
        console.log("Error fetching subscription plans:", error)
      );
  };

  useEffect(() => {
    if (subscriptionRef.current) return;
    subscriptionRef.current = true;
    fetchSubscriptionPlans();
    setActivePlanId(
      routeState.recurringType ? routeState.recurringType : "free"
    );
    setUserActivePlan(
      routeState.recurringType ? routeState.recurringType : "free"
    );
  }, []);

  const calculateSavePercentage = (monthly, yearly) => {
    const yearlyMonthly = yearly / 12;
    const save = ((monthly - yearlyMonthly) / monthly) * 100;
    return parseFloat(save.toFixed(1));
  };

  const handleButtonSubmit = (type) => {
    dispatch(
      setSelectedPlanDetails({
        priceId: type == "month" ? monthlyPlan?.priceId : yearlyPlan?.priceId,
        amount: type === "month" ? monthlyPlan?.amount : yearlyPlan?.amount,
        recurringType: type,
      })
    );
    navigate("/subscription/plans/checkout", {
      state: {
        priceId: type == "month" ? monthlyPlan?.priceId : yearlyPlan?.priceId,
        amount: type === "month" ? monthlyPlan?.amount : yearlyPlan?.amount,
        recurringType: type,
      },
    });
  };

  return (
    <div className="flex flex-col border rounded-lg p-4 bg-white gap-7 text-charcoal w-full overflow-auto">
      <button
        className="flex items-center cursor-pointer pl-4"
        onClick={() => {
          navigate(-1);
        }}
      >
        <ChevronLeftIcon className="w-4 h-4" fill="#4d4d4d" />
        <label className="text-xs font-medium text-charcoal">
          Back to active subscription
        </label>
      </button>
      {loading ? (
        <div className="gap-2.5 flex mt-16 flex-col">
          {Array.from({ length: 10 }, (x, i) => i).map((key) => {
            return (
              <div key={key} className="flex justify-between">
                <div
                  style={{
                    borderWidth: 1,
                  }}
                  className="flex rounded-lg w-full pl-3 pr-8 py-4 gap-1.5"
                >
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                  <div className="h-3 rounded bg-gray-200 w-1/4"></div>
                </div>
              </div>
            );
          })}
        </div>
      ) : error ? (
        <div className="flex flex-col items-center justify-center py-10 px-5">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center max-w-md">
            <h2 className="text-xl font-semibold text-red-600 mb-2">
              Unable to Load Subscription Plans
            </h2>
            <p className="text-gray-700 mb-4">
              {error || "An unexpected error occurred. Please try again."}
            </p>
            <button
              onClick={fetchSubscriptionPlans}
              className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg transition-colors duration-300"
            >
              Try Again
            </button>
          </div>
        </div>
      ) : subscriptionPlans.length > 0 ? (
        <div className=" px-10 py-10  h-9/10 overflow-auto">
          <div className="flex flex-col pr-10 text-wrap">
            <h1 className="text-3xl font-bold text-secondary">
              Plans & Pricing
            </h1>
            <p className="text-sm font-medium text-charcoal my-10">
              Choose the plan that best fits your recruitment needs. All plans
              include access to our core platform features with different levels
              of service.
            </p>
          </div>
          <div className="flex w-full gap-4 pb-10 pr-12">
            {/* Static Free PLan */}
            <div
              onClick={() => setActivePlanId("free")}
              className={`
                cursor-pointer border rounded-lg px-6 pt-4 pb-5 h-fixed w-1/3 shadow-md transition-all duration-300 ease-in-out relative transform
                ${
                  activePlanId == "free"
                    ? " bg-orange-400 shadow-md"
                    : "border-gray-300 bg-white"
                }
                hover:-translate-y-2 hover:scale-105 hover:z-10 flex-shrink-0
                `}
            >
              <div className="flex justify-between">
                <p
                  className={` text-md font-semibold pt-1 ${
                    activePlanId == "free" ? "text-white" : "text-secondary"
                  }`}
                >
                  Starter Plan
                </p>
                {userActivePlan === "free" ? (
                  <button className="text-white font-semibold border border-green-400 px-2 py-1 bg-green-500 rounded-full">
                    Active
                  </button>
                ) : null}
              </div>
              {/* <p
                className={`text-md font-semibold ${
                  activePlanId == "free" ? "text-white" : "text-secondary"
                }`}
              >
                Starter Plan
              </p> */}
              <h4
                className={`my-10 text-2xl font-bold ${
                  activePlanId == "free" ? "text-white" : "text-secondary"
                }`}
              >
                Free
              </h4>
              {/* <h3>$20</h3> */}
              <button
                onClick={(e) => {
                  activePlanId == "free"
                    ? handleButtonSubmit("free")
                    : setActivePlanId("free");
                }}
                className={`text-secondary font-semibold border px-2 py-2 rounded-lg  flex justify-center items-center
                ${activePlanId == "free" ? "bg-white" : "bg-orange-100"}`}
              >
                <span>Proceed for free</span>
                <span className="ml-2">
                  <RightLongArrowIcon className={"w-5 h-5"} fill={"#ff9900"} />
                </span>
              </button>
              <div
                className={`text-sm py-10 font-medium
                ${
                  activePlanId == "free" ? "text-white" : "text-charcoal"
                } overflow-auto flex-1`}
              >
                <p>Access to basic features including:</p>
                <ul className="list-disc ml-5 mt-2 space-y-1">
                  <li>Pay-per-job posting model</li>
                  <li>£10 fee per job posting</li>
                  <li>Basic candidate tracking</li>
                  <li>Standard email support</li>
                </ul>
                <p className="mt-2">
                  Perfect for individuals or small teams with occasional hiring
                  needs.
                </p>
              </div>
            </div>
            {/* API Fetched Plans */}
            {subscriptionPlans.map((plan) => {
              const isActive = activePlanId == plan?.recurringType;
              return (
                <div
                  key={plan._id}
                  onClick={() => setActivePlanId(plan?.recurringType)}
                  className={`
                cursor-pointer border rounded-lg px-6 pt-4 pb-5  h-fixed w-1/3 shadow-md
                transition-all duration-300 ease-in-out relative transform
                ${
                  isActive
                    ? " bg-orange-400 shadow-md"
                    : "border-gray-300 bg-white"
                }
                hover:-translate-y-2 hover:scale-105 hover:z-10 flex-shrink-0
                `}
                >
                  <div className="flex justify-between">
                    <p
                      className={` text-md font-semibold pt-1 ${
                        isActive ? "text-white" : "text-secondary"
                      }`}
                    >
                      {plan.recurringType == "year" ? "Yearly" : "Monthly"} Plan
                    </p>
                    {userActivePlan === plan.recurringType ? (
                      <button className="text-white font-semibold border border-green-400 px-2 py-1 bg-green-500 rounded-full">
                        Active
                      </button>
                    ) : plan?.recurringType == "year" &&
                      userActivePlan !== "year" ? (
                      <button className="text-white font-semibold border border-yellow-400 px-2 py-1 bg-yellow-400 rounded-full">
                        Save{" "}
                        {calculateSavePercentage(
                          monthlyPlan?.amount,
                          yearlyPlan?.amount
                        )}
                        %
                      </button>
                    ) : null}
                  </div>
                  <h4
                    className={`my-10 text-2xl font-bold ${
                      isActive ? "text-white" : "text-secondary"
                    }`}
                  >
                    £
                    {plan.recurringType == "year"
                      ? (plan?.amount / 12).toFixed(2)
                      : plan?.amount}{" "}
                    /month
                  </h4>
                  <button
                    className={`font-semibold text-secondary border px-2 py-2  rounded-lg flex items-center justify-center ${
                      isActive ? "bg-white" : "bg-orange-100"
                    }`}
                    onClick={(e) => {
                      isActive
                        ? handleButtonSubmit(plan?.recurringType)
                        : setActivePlanId(plan?.recurringType);
                    }}
                  >
                    <span>
                      Proceed{" "}
                      {plan.recurringType == "year" ? "Anually" : "Monthly"}
                    </span>
                    <span className="ml-2">
                      <RightLongArrowIcon
                        className={"w-5 h-5"}
                        fill={"#ff9900"}
                      />
                    </span>
                  </button>
                  <div
                    className={`text-sm py-10 font-medium ${
                      isActive ? "text-white" : "text-charcoal"
                    } overflow-auto flex-1`}
                  >
                    <p>
                      Billed £{plan.amount} per user{" "}
                      {plan.recurringType === "month" ? "monthly" : "annually"}.
                    </p>
                    {plan.recurringType === "month" ? (
                      <>
                        <p>Total is £ {plan?.amount * 12} per year.</p>
                        <p className="mt-4">
                          Access to premium features including:
                        </p>
                        <ul className="list-disc ml-5 mt-2 space-y-1">
                          <li>Unlimited job postings at no extra cost</li>
                          <li>Advanced candidate tracking</li>
                          <li>Priority email support</li>
                        </ul>
                        <p className="mt-2">
                          Ideal for growing teams with regular hiring needs.
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          £ {monthlyPlan?.amount * 12 - yearlyPlan?.amount}{" "}
                          cheaper this way.
                        </p>
                        <p className="mt-4">
                          Access to premium features including:
                        </p>
                        <ul className="list-disc ml-5 mt-2 space-y-1">
                          <li>Unlimited job postings at no extra cost</li>
                          <li>Advanced candidate tracking</li>
                          <li>Priority email support</li>
                        </ul>
                        <p className="mt-2">
                          Best value for established teams with ongoing
                          recruitment.
                        </p>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-10 px-5">
          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center max-w-md">
            <h2 className="text-xl font-semibold text-gray-700 mb-2">
              No Subscription Plans Available
            </h2>
            <p className="text-gray-600 mb-4">
              We couldn't find any subscription plans. This could be due to a
              configuration issue.
            </p>
            <button
              onClick={fetchSubscriptionPlans}
              className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-lg transition-colors duration-300"
            >
              Refresh
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionPlanPage;
